import { render, staticRenderFns } from "./SPIFRPDFRatios.vue?vue&type=template&id=ed68575e"
import script from "./SPIFRPDFRatios.vue?vue&type=script&lang=js"
export * from "./SPIFRPDFRatios.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports